import { render, staticRenderFns } from "./fball-important.vue?vue&type=template&id=d83c7bb8&scoped=true"
import script from "./fball-important.vue?vue&type=script&lang=js"
export * from "./fball-important.vue?vue&type=script&lang=js"
import style0 from "./fball-important.vue?vue&type=style&index=0&id=d83c7bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83c7bb8",
  null
  
)

export default component.exports